import type { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { searchChallengesV2Api } from '@repo/sdk';
import { z } from 'zod';

export function registerSearchChallenges(server: McpServer): void {
  server.registerTool(
    'search_challenges',
    {
      title: 'Search English challenges',
      description:
        'Search Cool Mate challenges (words, idioms, phrasal verbs, slang) by query string. Returns matching challenges with id, slug, title and type.',
      inputSchema: { query: z.string().min(1).max(200) },
    },
    async ({ query }) => {
      const { data } = await searchChallengesV2Api(query);
      return {
        content: [{ type: 'text', text: JSON.stringify(data?.data ?? []) }],
      };
    },
  );
}
